"use client";
import React, { useCallback, useState } from "react";
import Head from "next/head";
import AppDesignForm from "./AppDesignForm";
import BrandNeededWrapper from "~/components/BrandNeededWrapper.jsx";
import { useAppProps } from "~/app/_apps/AppPropsContext";

export default function SettingsAppDesignPage({ ref }) {
    const { appProps } = useAppProps();
    const [resetKey, setResetKey] = useState(0);

    const onResetClick = useCallback(() => {
        setResetKey(resetKey + 1);
    }, [resetKey]);

    return (
        <>
            <Head>
                <title>App Design Settings</title>
            </Head>
            <BrandNeededWrapper appProps={appProps}>
                <AppDesignForm appProps={appProps} key={resetKey} onResetClick={onResetClick} ref={ref} />
            </BrandNeededWrapper>
        </>
    );
}
